<script>
    import { searchAndRemoveClasses,nextSiblingUntil,previousSiblingUntil,closestSelector } from "../../commonjs/helpers";
    import { mapActions, mapState, mapGetters } from 'vuex';
    import LiquidCompiler  from "../../components/pagesbuilder/liquid/LiquidCompiler";
    import AnimationsMixin from "../../author/pagesbuilder/mixins/AnimationsMixin";
    export default {
        name: "NodeState",
        mixins: [AnimationsMixin],
        data(){
            return {
                topbarStatus: "", //set to before/after login,
                footerStatus: "", //set to before/after login,
                context: [],
                responsiveFunctions: [], // Will be populated by responsive mixins. Each responsive function should have 2 parameters, device and node
            }
        },
        computed: {
            ...mapState([                
                'classSelectors',
                'imagePath'
            ]),
            ...mapState('UiInteractions', [
                'activeDevicePreview'
            ]),
            ...mapState('topbar', [
                'schoolTopbarData',
                'pageTopbarData',
            ]),
            ...mapState('footer', [
                'schoolFooterData',
                'pageFooterData',
            ]),
            ...mapState('elements',[
                'elementStates'
            ]),
            ...mapState('sections',[
                'sectionStates'
            ]),
            ...mapState('components',[
                'componentStates'
            ]),
            ...mapGetters('pages',[
                'isPageContext'
            ]),
            ...mapGetters('UiInteractions',[
                'selectedNodeState'
            ]),
            ...mapState('pages',[
                'pageContext',
            ]),
            getDefaultDataStructure () {
                //Overridden by section/component/element
            },
            myNode () {
                //Overridden by section/component/element
            },
            myId () {
                //Overridden by section/component/element
            },
            myState () {
                //Overridden by section/component/element
            },
            myData () {
                //Overridden by section/component/element
            },
            myNodeType () {
                //Overridden by section/component/element
            },
            myDataNodeAttribute () {
                return this.myNode && this.myNode.getAttribute("data-node-type") ? this.myNode.getAttribute("data-node-type") : "";
            },
            isTopbar () {
                if (this.sectionType && this.sectionType.toLowerCase().indexOf("topbar") !== -1) {
                    return true;
                }

                return false;
            },
            isFooter () {

                if (this.sectionType && this.sectionType.toLowerCase().indexOf("footer") !== -1) {
                    return true;
                }

                return false;
            },
            inTopbar () {
                return this.hasContext("school-topbar") || this.hasContext("page-topbar");
            },
            inFooter() {
                return this.inSchoolFooter || this.inPageFooter;
            },
            inSchoolTopbar () {
                return this.hasContext("school-topbar");
            },
            inPageTopbar () {
                return this.hasContext("page-topbar");
            },
            inSchoolFooter () {
                return this.hasContext("schoolFooter");
            },
            inPageFooter () {
                return this.hasContext("pageFooter");
            },
            inMegamenu () {
                return this.hasContext("megamenuWrapper");
            },
            canBeEditedByCurrentUser() {
                if (window.me.isAInstructor){
                    return !this.inTopbar && !this.inFooter
                }
                return true;
            }
        },
        methods: {
            ...mapActions('UiInteractions',[
                'setElementStatus'
            ]),
            ...mapActions([
                'setChangesAreSaved'
            ]),
            changeMyData() {
                //Overridden by section/component/element
            },
            cloneSelf() {
                //Overridden by section/component/element
            },
            createMyId () {
                //Overridden by section/component/element
            },
            removeMe() {
                //Overridden by section/component/element
            },
            insertNode (nodeToAdd, how = "afterend", noInitialisation = false, withLink = false) {

                if (this.nodeIsLinked && this.getClosestAnchor()) {
                    if (withLink) {
                        const node = this.getClosestAnchor().cloneNode();
                        node.appendChild(nodeToAdd);
                        this.getClosestAnchor().insertAdjacentElement(how , node);
                    } else {

                        if (this.inTopbar && !this.inMegamenu) {
                            let flexWrapperForTopbarNode = document.createElement("div");
                            flexWrapperForTopbarNode.setAttribute("class","flex-item with-flexible-parts va-c");
                            flexWrapperForTopbarNode.appendChild(nodeToAdd);
                            this.getClosestAnchor().parentNode.insertAdjacentElement(how , flexWrapperForTopbarNode);
                        } else {
                            this.getClosestAnchor().insertAdjacentElement(how , nodeToAdd);
                        }

                    }
                } else {

                    //elements added in topbar need an extra wrapper
                    if (this.inTopbar && !this.inMegamenu) {
                        let flexWrapperForTopbarNode = document.createElement("div");
                        flexWrapperForTopbarNode.setAttribute("class","flex-item with-flexible-parts va-c");
                        flexWrapperForTopbarNode.appendChild(nodeToAdd);
                        if (how === "beforeend") {
                            this.myNode.insertAdjacentElement(how, flexWrapperForTopbarNode);
                        } else {
                            this.myNode.parentNode.insertAdjacentElement(how, flexWrapperForTopbarNode);
                        }
                    } else {
                        this.myNode.insertAdjacentElement(how, nodeToAdd);
                    }

                }

                if (!noInitialisation) {
                    this.initElementsManager(nodeToAdd);
                    this.initComponentsManager(nodeToAdd);
                }
            },
            $t(val){
                return window.LWTranslate.get(val);
            },
            renderTemplate (template,data) {
                return LiquidCompiler.renderFile(template, data);
            },
            acquireSectionTemplate (liquidFile, data = {}) {
                return this.renderTemplate(liquidFile, data).then( output => {
                    return output ;
                }).catch(error => {
                    console.log(error);
                })
            },
            getMappedClasses (mappedData) {
                let classes = [];

                if (mappedData) {

                    Object.keys(mappedData).map(value => {
                        let classNames = mappedData[value];

                        if (!Array.isArray(classNames) && !(classNames instanceof Object) ) {
                            classNames = [classNames];
                        }

                        Object.keys(classNames).map(index => {
                            let className = classNames[index];
                            classes.push(className);
                        })

                    })
                }
                return classes;
            },
            findMyMegamenuWrapper () {
                this.megamenuWrapper = closestSelector(this.myNode,"." + this.classSelectors.megamenuWrapper);
                this.megamenuWrapperId = this.megamenuWrapper ? this.megamenuWrapper.getAttribute("data-megamenu-id") : "";
                this.megamenuComponentWrapperId = this.megamenuWrapper ? this.megamenuWrapper.getAttribute("data-component-id") : "";

                if(this.componentStates[this.megamenuComponentWrapperId]) {
                    let sectionId = this.componentStates[this.megamenuComponentWrapperId].sectionId ? this.componentStates[this.megamenuComponentWrapperId].sectionId : "";

                    if (sectionId) {
                        if (this.sectionStates[sectionId]) {
                            this.sectionId = sectionId;
                            this.sectionNode = this.sectionStates[sectionId].sectionNode;
                        }
                    }
                }
            },
            findNodeState (nodeId) {
                if (this.componentStates[nodeId]) {
                    return this.componentStates[nodeId];
                } else if (this.elementStates[nodeId]) {
                    return this.elementStates[nodeId];
                } else if (this.sectionStates[nodeId]) {
                    return this.sectionStates[nodeId];
                }

                return null;
            },
            /**
             * @param Object valueToClassMap
             * @param Object params
             * @param Node
             * Parses an object with { value : class } mapping and checks if class exists in node and returns the key for that class
             * @returns String
             **/
            getKeyForMatchingClass (valueToClassMap,params,node) {

                let classVal = params && params.defaultValue ? params.defaultValue : "";

                if (typeof node === "undefined" && this.myNode) {
                    node = this.myNode;
                }

                Object.keys(valueToClassMap).map(value => {
                    let classNames = valueToClassMap[value]; //can be string or array of strings

                    if (!Array.isArray(classNames)) {
                        classNames = [classNames];
                    }

                    classNames.map(className => {
                        if (node.classList.contains(className)) {
                            classVal = value;
                        }
                    });
                })

                return classVal;
            },
            /**
             * @param Object valueToClassMap
             * @param Object params
             * @param Node
             * Parses an object with { value : class } mapping and checks if class exists in node and returns the key for that class
             * @returns String
             **/
            getKeyForMatchingClassSet (valueToClassMap,params,node) {

                let classVal = params && params.defaultValue ? params.defaultValue : "";

                if (typeof node === "undefined" && this.myNode) {
                    node = this.myNode;
                }

                Object.keys(valueToClassMap).map(value => {
                    let classNames = valueToClassMap[value]; //can be string or array of strings

                    if (!Array.isArray(classNames)) {
                        classNames = [classNames];
                    }

                    if(classNames.every((className)=>{
                        return node.classList.contains(className);
                    })){
                        classVal = value;
                    }
                })

                return classVal;
            },
            applyClass (params , node) {
                if (typeof node === "undefined" && this.myNode) {
                    node = this.myNode;
                }

                if (params && params.classesToRemove) {
                    searchAndRemoveClasses(node,params.classesToRemove,params.how,params.debug);
                }


                if (params && params.newClass) {
                    let newClass = params.newClass;

                    //typecast to array to be able to add multiple classes
                    if (!Array.isArray(newClass) && !(newClass instanceof Object) ) {
                        newClass = [params.newClass];
                    }

                    Object.keys(newClass).map(index => {
                        let className = newClass[index];
                        //use array to detect if newClass contains a space and split the space to detect single classes
                        if (newClass[index].indexOf(" ") !== -1) {
                            className = newClass[index].split(" ");
                        } else if (!Array.isArray(newClass[index])) {
                            className = [newClass[index]];
                        }

                        for (let index2 in className) {
                            if (!className.hasOwnProperty(index2)) {
                                continue;
                            }
                            if (className[index2]) {
                                node.classList.add(className[index2]);
                            }
                        }
                    })
                }

                //this.setChangesAreSaved(false);

            },
            getStyleProperty (styleProp , params , node) {

                if (typeof node === "undefined") {
                    node = this.myNode;
                }

                let valueToReturn = params && (params.defaultValue || params.defaultValue === 0 ) ? params.defaultValue : "";

                if (node && node.style && node.style[styleProp]) { //when set inline

                    valueToReturn = node.style[styleProp];

                } else if (node && node.style && window.getComputedStyle(node)[styleProp] && window.getComputedStyle(node)[styleProp] !== "none") { //when set from css styles

                    valueToReturn = window.getComputedStyle(node)[styleProp];
                }

                if (params.parse == "float") {
                    valueToReturn = parseFloat(valueToReturn);
                }

                return valueToReturn;
            },
            applyStyle (params,node) {

                if (typeof node === "undefined") {
                    node = this.myNode;
                }

                //There is a problem with the empty objects that are handled as arrays so this is our walkthrough
                let existingStyles = this.myData.styles? copyJson(this.myData.styles) : {};

                /**
                 //TODO
                 * ID creation is used to cover cases where css must be applied to nested nodes passed as args (i.e screen element overlay) that aren't initialised as an element/component,
                 * these should be also transformed to elements/components in the future
                 **/
                if(!node.id ){
                    node.setAttribute('id', 'el_' + window.createTimeID() );
                }

                let target = '#' + this.myNode.id;

                if(this.myNode !== node){
                    target += ' #' + node.id;
                }

                if(params.targetSelector){
                    // Replace . with __DOT__ because we cannot save mongo keys that contain the . char
                    target += ' ' + params.targetSelector.replace('.', '__DOT__');
                }

                if(params.targetState){
                    target += params.targetState;
                }

                if(!existingStyles[this.activeDevicePreview]){
                    existingStyles[this.activeDevicePreview] = {};
                }
                if(!existingStyles[this.activeDevicePreview][target]){
                    existingStyles[this.activeDevicePreview][target] = {};
                }

                existingStyles[this.activeDevicePreview][target][params.styleProp] = params.valuePostFix ? params.value + params.valuePostFix : params.value;

                this.changeMyData({
                    styles: existingStyles
                });

                this.setChangesAreSaved(false);

                window.eventBus.$emit('custom-styles-updated');
            },
            applyInlineStyle (params,node) {

                if (typeof node === "undefined") {
                    node = this.myNode;
                }
                node.style[params.styleProp] = params.valuePostFix ? params.value + params.valuePostFix : params.value;
            },
            getNodeHtmlTagName (node) {
                if (typeof node === "undefined") {
                    node = this.myNode;
                }

                return node.tagName.toLowerCase();
            },
            updateHTML (content) {
                this.myNode.outerHTML = content;
                this.findMyNode();
                this.syncNestedNodes();
            },
            swapPosition (direction,withScroll) {
                const node = this.nodeIsLinked && this.getClosestAnchor() ? this.getClosestAnchor()  : this.inTopbar && !this.inMegamenu ? this.myNode.parentNode : this.myNode;
                let parentNode = node.parentNode;

                if (!parentNode) {
                    return;
                }

                let parentChildren = Array.from(parentNode.children);

                if (direction === "down" ) {
                    parentChildren.map( (childNode,index) => {
                        if (childNode ===  node) {
                            parentNode.insertBefore( node,parentChildren[index + 2]? parentChildren[index + 2] : null); //if node.nextSibling ===  null its appended as lastChild
                        }
                    })
                } else if (direction === "up") {
                    parentChildren.map( (childNode,index) => {
                        if (childNode ===  node) {
                            parentNode.insertBefore( node, parentChildren[index - 1]? parentChildren[index - 1] :  node);
                        }
                    })
                }

                window.eventBus.$emit("recompute-layout");
                this.setChangesAreSaved(false);
                if (withScroll) {
                    window.scrollTo({
                        top: node.offsetTop,
                        behavior: "smooth"
                    })
                    // $("html").animate({scrollTop : $(node).offset().top - 80},1000);
                }

            },
            hasAdjacentSibling (direction) {

                const node = this.nodeIsLinked && this.getClosestAnchor() ? this.getClosestAnchor()  : this.inTopbar && !this.inMegamenu ? this.myNode.parentNode : this.myNode;

                if (direction == "up") {
                    return node.previousElementSibling;
                }

                if (direction === "down" ) {
                    return node.nextElementSibling;
                }

                if (!direction ) {
                    return {
                        "up": node.previousElementSibling,
                        "down": node.nextElementSibling
                    }
                }

                return false;
            },
            eligibleToSwapPosition (direction) {

                let oppositeDirection = direction === "up" ? "down" : "up"; //use opposite direction when asking the sibling element
                let nodeToSwap = this.hasAdjacentSibling(direction);

                if (!nodeToSwap) {
                    return false;
                }

                let swapNodeId = nodeToSwap.getAttribute("id");

                let swapNodeState = this.findNodeState(swapNodeId);
                if (swapNodeId && swapNodeState) {
                    return swapNodeState && swapNodeState.canBeSwapped[oppositeDirection] && this.canBeSwapped[direction];
                }

                return true;
            },
            bindElementToParent (parent, stateThatTriggeredBubbling) {
                if(parent.state){
                    // console.log("===========================");
                    // console.log('id " , ' , this.myId  , this.myNode);
                    // console.log( 'bubbling to : ' , parent.state.myId , parent.state.myNode);
                    // console.log("===========================");
                    parent.state.bindNestedElement(stateThatTriggeredBubbling);
                }
            },
            bindNestedElement (stateThatTriggeredBubbling) {
                if (!this.nestedElementIds.includes(stateThatTriggeredBubbling.elementId)) {
                    // console.log("id : " , this.myId , " adding element : " , stateThatTriggeredBubbling.elementId ,stateThatTriggeredBubbling.myNode);
                    this.nestedElementIds.push(stateThatTriggeredBubbling.elementId);

                    if (this.givesContextToChildren) {
                        stateThatTriggeredBubbling.setContext(this);
                    }

                    let parent = this.getParent();

                    if(parent){
                        this.bindElementToParent(parent, stateThatTriggeredBubbling);
                    }
                }
            },
            getContext(){
                return this.context;
            },
            setContext (parentState) {
                let parentNodeType = parentState.myNodeType;
                let contextData = {
                    id: parentState.myId,
                    type: parentNodeType
                }

                if (parentNodeType && parentNodeType.toLowerCase().indexOf("section") > -1) {
                    this.sectionId = parentState.sectionId;
                    this.sectionNode = parentState.sectionNode;
                }


                this.context.push(contextData);
            },
            hasContext (key) {
                let contextFound;

                if (Array.isArray(key)) {
                    contextFound = this.context.filter(contextData => key.includes(contextData.type));
                } else {
                    contextFound = this.context.filter(contextData => contextData.type === key);
                }

                return contextFound.length ? contextFound : false;
            },
            bindComponentToParent (parent,stateThatTriggeredBubbling) {
                if(parent.state){
                    parent.state.bindNestedComponent(stateThatTriggeredBubbling);
                }
            },
            bindNestedComponent (stateThatTriggeredBubbling) {
                //check if componenths has already registered
                if (!this.nestedComponentIds.includes(stateThatTriggeredBubbling.componentId)) {
                    this.nestedComponentIds.push(stateThatTriggeredBubbling.componentId);

                    if (this.givesContextToChildren) {
                        stateThatTriggeredBubbling.setContext(this);
                    }

                    let parent = this.getParent();

                    if(parent){
                        // this.$nextTick( () => {
                        this.bindComponentToParent(parent, stateThatTriggeredBubbling);
                        // })
                    }
                }

            },
            unregisterParentNestedItems (parent, nestedIds) {
                if(parent.state){
                    parent.state.unregisterNestedItems(nestedIds);
                }
            },
            unregisterNestedItems (nestedIds) {

                if(nestedIds.componentIds){
                    this.nestedComponentIds = this.nestedComponentIds.filter(id => {
                        return nestedIds.componentIds.indexOf(id) === -1;
                    });
                }
                if(nestedIds.elementIds){
                    this.nestedElementIds = this.nestedElementIds.filter(id => {
                        return nestedIds.elementIds.indexOf(id) === -1;
                    });
                }

                let parent = this.getParent();

                if(parent){
                    this.$nextTick( () => {
                        this.unregisterParentNestedItems(parent, nestedIds);
                    })
                }

            },
            getParent (){

                if(!this.myNode || !this.myNode.parentNode){
                    return false;
                }

                let parentNode = this.myNode.parentNode.closest(`${this.classSelectors.nodeWithDataTypeAttribute}, .${this.classSelectors.sectionNode}`);

                // //TODO this forces us to have the data-node-type as the first child of the megamenu wrapper
                if(this.myNode.classList.contains('js-megamenu-wrapper')){
                    parentNode = this.sectionStates[this.sectionId].sectionNode;

                }

                if(!parentNode || !parentNode.id){
                    return false;
                }

                return {
                    id: parentNode.id,
                    state: this.findNodeState(parentNode.id)
                }
            },
            setTopbarStatus () {

                for (let topbarStatus in this.schoolTopbarData) {
                    if (!this.schoolTopbarData.hasOwnProperty(topbarStatus)) {
                        continue;
                    }

                    if (this.sectionId === this.schoolTopbarData[topbarStatus].sectionId) {
                        this.topbarStatus = topbarStatus;
                    }
                }

                for (let topbarStatus in this.pageTopbarData) {
                    if (!this.pageTopbarData.hasOwnProperty(topbarStatus)) {
                        continue;
                    }

                    if (this.sectionId === this.pageTopbarData[topbarStatus].sectionId) {
                        this.topbarStatus = topbarStatus;
                    }
                }
            },
            setFooterStatus () {

                for (let footerStatus in this.schoolFooterData) {
                    if (!this.schoolFooterData.hasOwnProperty(footerStatus)) {
                        continue;
                    }

                    if (this.sectionId === this.schoolFooterData[footerStatus].sectionId) {
                        this.footerStatus = footerStatus;
                    }
                }

                for (let footerStatus in this.pageFooterData) {
                    if (!this.pageFooterData.hasOwnProperty(footerStatus)) {
                        continue;
                    }

                    if (this.sectionId === this.pageFooterData[footerStatus].sectionId) {
                        this.footerStatus = footerStatus;
                    }
                }
            },
            handleMouseOver (event) {
                if (this.canBeEditedByCurrentUser) {
                    this.setElementStatus({
                        hoveredElement: event.target,
                        hoveredSection: this.sectionNode,
                    })
                }
            },
            handleMouseOut (event) {
                if (this.canBeEditedByCurrentUser) {
                    let originalStatus = {
                        hoveredElement: null,
                        hoveredSection: null,
                        // selectedSection:null,
                    };


                    if(!event.relatedTarget) {
                        return this.setElementStatus(originalStatus);
                    }

                    if ( event.relatedTarget && !event.relatedTarget.closest(`.${this.classSelectors.sectionNode}`) && !event.relatedTarget.closest(`.${this.classSelectors.authoringToolNode}`) ){
                        return this.setElementStatus(originalStatus);
                    }
                }
            },
            handleClick (event) {                
                if (this.nodeIsLinked && !this.linksEnabled) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                
                if (this.canBeEditedByCurrentUser) {
                    this.setElementStatus({
                        selectedElement: event.target,
                        selectedSection: this.sectionNode
                    });
                }
               
                if (this.nodeIsLinked && this.linksEnabled) {
                    this.handleLinkSelection();
                    return;   
                }

                if(this.bubbles){
                    const parentNode = this.myNode.parentNode.closest('[id]');
                    if(!parentNode){
                        return;
                    }   
                    const parentId = parentNode.getAttribute('id');
                    this.bubbleClick(parentId, parentNode, event );
                }
                

                
            },
            bubbleClick(targetId, node, event){
                if(!targetId || targetId == 'pageContent' ){
                    return;
                }

                if(!this.findNodeState(targetId) || !this.findNodeState(targetId).handleClick(event) ){
                    let parentNode = node.parentNode.closest('[id]');
                    if(!parentNode){
                        return;
                    }                    
                    let parentId = parentNode.getAttribute("id");                    
                    this.bubbleClick(parentId, parentNode, event );
                }
            }
        }
    }
</script>

